module.exports = __webpack_public_path__ + "static/media/2.f721bb95.gif";